import React, { useState } from 'react';
import '../css/MasterPage.css';
import LeafStorm from '../components/LeafStorm';
import Hamburger from '../components/Hamburger';
import Menu from '../components/Menu';

export default function Examples({ setActivePage }) {
    const [open, setOpen] = useState(false);

    return (
        <div className='pageContainer'>
            <LeafStorm active={open} />
            <div className='navBar'>
                <a className='anchor'>🌸</a>
                <Hamburger open={open} setOpen={setOpen} />
                {open && <Menu isOpen={open} setActivePage={setActivePage} />}
            </div>
            <div className='phantomMenuContainer' />
        </div>
    )
}